export const getBasket = state => state.addToCart.basket;
export const isAddedToCart = state => state.addToCart.addedToCart;
export const getMaxLimit = state => state.addToCart.maxLimit;
export const getError = state => state.addToCart.error;